/** Vite `base` with trailing slash stripped (`""` locally, `"/card"` in the API image). */
export function cardBasePath(): string {
	return import.meta.env.BASE_URL.replace(/\/$/, "");
}

export function withCardBase(path: string): string {
	const base = cardBasePath();
	const [pathname, query] = path.split("?");
	const normalized = pathname.startsWith("/") ? pathname : `/${pathname}`;
	const suffix = query ? `?${query}` : "";
	return `${base}${normalized}${suffix}`;
}
